import React, { useContext, useRef } from 'react';
import { useOutsideClickForTwoRef } from '../../../../Hooks/useOutsideClickForTwoRef';
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import { Link, useLocation } from 'react-router-dom';
import showhide from "../../../../Assets/ShowHide.svg";
import { formatDate, getCachedMediaUrl } from '../../../../lib/utils/utils';
import { CouponContext } from '../../../../Context/Coupons/CouponContext';
import DotsVertical from '../../../../Assets/OrderManagement/DotsVertical.svg';
import { useDispatch, useSelector } from 'react-redux';
import KebabMenu from './KebabMenu';
import { closeCouponKebabMenu, fetchCoupons, openCouponKebabMenu } from '../../../../Features/couponsSlice';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { updateCoupon } from '../../../../lib/utils/apiCalls';

function CouponListItem({ coupon, isSelected, couponType, status }) {
    const location = useLocation();
    const dispatch = useDispatch();

    const { selectedCoupons, setSelectedCoupons } = useContext(CouponContext);

    const kebabCouponId = useSelector((state) => state.coupons.couponKebab.couponId);

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    const isToggleDisabled = status.name === "Expired";

    const handleToggleClick = async () => {
        let visibilityValue;

        if(coupon.isVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            const response = await updateCoupon(callData, coupon.id);
            if(response?.status === 200) {
                dispatch(fetchCoupons());
            }
        }
        catch(err) {
            showToast('Failed to update coupon visibility.', 'error');
        }
    }

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeCouponKebabMenu());
    });

    const handleSelectBoxClick = () => {
        if(selectedCoupons.includes(coupon.id)) {
            const filteredList = selectedCoupons.filter(item => item !== coupon.id);
            setSelectedCoupons(filteredList);
        }
        else {
            setSelectedCoupons([ ...selectedCoupons, coupon.id ]);
        }
    }

    const handleOpenKebab = () => {
        if(kebabCouponId === coupon.id) {
            dispatch(closeCouponKebabMenu());
        }
        else {
            dispatch(openCouponKebabMenu(coupon.id));
        }
    }

    return (
        <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA]">
            <div className="flex items-center gap-2 w-[calc((35/100)*(100%-44px))] px-[10px] py-[6px]">
                <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryColor' : 'border-[#D1D5DB]'} `} >
                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                </div>

                <Link to={`${location.pathname}/coupon/${coupon.id}`} className="w-[calc(100%-32px)] flex items-center gap-2">
                    {
                        coupon.pic ? 
                        <div className="size-16 flex items-center justify-center rounded-lg overflow-hidden">
                            <img className='size-full object-cover' src={getCachedMediaUrl(coupon.pic)} alt="" />
                        </div> : 
                        <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                    }

                    <h1 className='font-semibold text-[14px] leading-6 text-[#121212] w-[calc(100%-64px)] whitespace-nowrap overflow-hidden text-ellipsis'>{coupon.couponName}</h1>
                </Link>
            </div>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{couponType}</h2>

            <h2 className="w-[calc((13/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">
                {
                    formatDate(coupon.startDate)
                    ?.split(' ')
                    .map((item, index) => index === 1 ? item.slice(0, 3) : item)
                    .join(' ')
                }
            </h2>

            <h2 className="w-[calc((13/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">
                {
                    formatDate(coupon.endDate)
                    ?.split(' ')
                    .map((item, index) => index === 1 ? item.slice(0, 3) : item)
                    .join(' ')
                }
            </h2>

            <div className="w-[calc((12/100)*(100%-44px))] px-[10px] py-[26px]">
                <h2 className={`${status?.colors} px-3 py-[2px] rounded-xl text-[14px] leading-5 font-medium w-24 text-center`}>{status.name}</h2>
            </div>

            <div className="w-[calc((12/100)*(100%-44px))] px-[10px] py-[26px]">
                <button onClick={handleToggleClick} disabled={isToggleDisabled} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${coupon.isVisible && !isToggleDisabled ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${coupon.isVisible && !isToggleDisabled ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="w-[44px] flex items-center justify-center">
                {
                    selectedCoupons?.length === 0 && 
                    <div onClick={handleOpenKebab} ref={kebabButtonRef} className='relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer'>
                        <img src={DotsVertical} alt="" />

                        {
                            kebabCouponId === coupon.id && 
                            <KebabMenu 
                                boxRef={kebabRef} 
                                coupon={coupon} 
                                status={status} 
                            />
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default CouponListItem;
